var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu-item',{attrs:{"disabled":_vm.disabled,"title":_vm.title,"icon-name":_vm.iconName,"showNewBadge":_vm.showNewBadge,"small":_vm.small,"show-beta-badge":_vm.showBetaBadge,"on-click":_vm.navigate,"selected":_vm.selected,"badge-text":_vm.badgeText,"badge-bg-color":_vm.badgeBgColor,"badge-text-color":_vm.badgeTextColor}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }